import React from 'react';

const PenPaper: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <circle cx="64" cy="64" r="57" stroke="#fff" strokeWidth="4"></circle>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M67.777 62.044l25.473 14.86-33.016 19.158-25.482-14.424 13.437-7.983"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M76.818 38.582l-6.99-3.991c-1.212-.694-1.937.2-1.937.2-3.452 5.34-8.945 15.327-12.903 23.955-4.425 9.617-3.118 11.964-3.118 11.964-.315.893-.82 2.718.095 3.23.906.514 2.213-.807 2.823-1.539 0 0 2.728-.114 8.926-8.98C69.18 55.62 74.444 46.65 77.628 40.34c.286-.56-.105-1.368-.81-1.767v.01z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M63.762 34.01a96.485 96.485 0 00-8.163 14.216"
    ></path>
    <path
      stroke="#fff"
      strokeWidth="4"
      d="M54.988 58.746l8.726 4.675m12.608-25.124l1.897-3.317c.23-.39-.057-.978-.63-1.311l-3.9-2.224c-.572-.332-1.23-.275-1.45.124l-1.907 3.307"
    ></path>
  </svg>
);

export default PenPaper;
